export default class StaffDto {
  serialNumber;
  fmNumber;
  belongs;
  name;
  email;
  endDate;
  password;

  constructor(data) {
    this.serialNumber = data.serialNumber;
    this.fmNumber = data.fmNumber;
    this.belongs = data.belongs;
    this.name = data.name;
    this.email = data.email;
    this.endDate = data.endDate;
    this.password = data.password;
  }
}
